/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router';

import Logo from '@/components/atoms/Logo';

export default function Forbidden() {
    const getLogoColor = () => {
        if (window?.location?.href?.includes('localhost')) return 'red';
        else if (window?.location?.href?.includes('staging')) return '#1e90FF';
        return undefined;
    };

    return (
        <div className="flex flex-col h-screen w-screen">
            <div className="border-b">
                <div className="px-4">
                    <div className="flex flex-row items-center mt-2 mb-5 h-10">
                        <Link to="/">
                            <Logo className="h-8 w-8 mr-4" color={getLogoColor()} />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="h-full overflow-hidden flex justify-center mt-10">
                <div className="text-center">
                    <AlertTriangle className="mx-auto h-12 w-12 text-yellow-400" />
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">403</h1>
                    <p className="mt-6 text-base leading-7 text-gray-600">Access Forbidden</p>
                    <p className="mt-2 text-sm text-gray-500">
                        If you've ended up here, it's because you're not allowed to access this page.
                    </p>
                    <div className="mt-10">
                        <a
                            href="https://heal.dev"
                            // eslint-disable-next-line max-len
                            className="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                        >
                            Go back home
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
